import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { countOpenCartLines } from "../utility/signupCart";
import { fetchMySignups } from "../utility/submitSignup";

const listeners = new Set();

export const refreshDueSignupCount = () => {
  listeners.forEach((listener) => listener());
};

export const useDueSignupCount = (tournamentId, { enabled = true } = {}) => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [epoch, setEpoch] = useState(0);

  useEffect(() => {
    const listener = () => setEpoch((value) => value + 1);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  useEffect(() => {
    if (!enabled || !user?.id) {
      setCount(0);
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const data = await fetchMySignups();
        if (!cancelled) setCount(countOpenCartLines(data, tournamentId));
      } catch (_) {
        if (!cancelled) setCount(0);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [user?.id, tournamentId, epoch, enabled]);

  return count;
};
